module.exports = __webpack_public_path__ + "../resources/img/ic-re-minus-default.d572c9aa.svg";